module Meevo.Plugins.DocsAndForms {


    const haveNotSubmittedForms = () => (services: IGroupedByServiceForm[], submittedForms: { formId: string; serviceId: string }[]) => {
        return services.filter((service) => {
            return service.forms.filter((form) => {
                const row = _(submittedForms)
                    .findWhere({id: form.id, serviceId: form.appointmentServiceId});

                return !row;
            }).length > 0;
        });
    };


    angular.module('meevo.plugins.docsAndForms')
        .filter('haveNotSubmittedForms', haveNotSubmittedForms);


    const notSubmittedForms = () => (forms: IClientFormService[], submittedForms: { formId: string; serviceId: string }[]) => {
        return forms.filter((form) => {
            const row = _(submittedForms)
                .findWhere({id: form.id, serviceId: form.appointmentServiceId});

            return !row;
        });
    };


    angular.module('meevo.plugins.docsAndForms')
        .filter('notSubmittedForms', notSubmittedForms);
}
